//export var NET_IP = "http://10.0.5.155:3400";
//export var NET_IP = "https://event-participants.onrender.com";
//192.168.3.8:3400
//http://10.0.5.155:3400

export var NET_IP = "https://termiite.pythonanywhere.com";
